import { DiscountKindEnum } from '../../../generated/api.graphql';

/**
 * Whether a discount takes a percentage off or a fixed amount. Paired with
 * `Discount.numericAmount` it replaces the guess the backend made from the `amount` string.
 * Wrapped rather than re-exported because `@vp/common`'s `exports` map publishes no
 * `./generated/api.graphql`, so `@vp/admin` reaches the values only as
 * `API.App.Discount.DiscountKind.PERCENTAGE`.
 */
export const DiscountKind = Object.freeze({
  PERCENTAGE: DiscountKindEnum.Percentage,
  FIXED_AMOUNT: DiscountKindEnum.FixedAmount,
});
export type DiscountKind = (typeof DiscountKind)[keyof typeof DiscountKind];
